import { Component, OnInit } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { SessionService } from 'src/app/services/session/session.service';
import { ThisReceiver } from '@angular/compiler';
import { ConfigurationCompanyServiceMock } from 'src/mocks/ConfigurationCompanyServiceMock';
import { WizardProductService } from 'src/app/services/product/wizard/wizard-product.service';
import { ConfigurationsEnum } from 'src/app/Enums/ConfigurationsEnum';
import { ConfigurationOptionsEnum } from 'src/app/Enums/ConfigurationOptionsEnum';
import { ConfigurationCompanyService } from 'src/app/services/configuration-company/configuration-company.service';

interface OptionsNode {
  name: string;
  id: string;
  dataTest?: string;
  children?: OptionsNode[];
  classIcon: string,
  nameIcon: string,
  url: string,
  show: boolean
}
interface ExampleFlatNode {
  expandable: boolean;
  id: string;
  dataTest?: string;
  name: string;
  level: number;
  classIcon: string,
  nameIcon: string,
  url: string,
  show: boolean
}
@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})

export class SideMenuComponent implements OnInit {

  get urlCurrentPage(): string {
    return this.router.url;
  }

  get nameUser(): string {
    return this.sessionService.getDetails().fullName
  }
  get emailUser(): string {
    return this.sessionService.getDetails().email
  }

  private _showNfceMenu: boolean = false;
  get showNfceMenu(): boolean {
    return this._showNfceMenu;
  }

  private _showUserListMenu: boolean = false;
  get showUserListMenu(): boolean {
    return this._showUserListMenu;
  }

  private readonly TREE_DATA: OptionsNode[] = [
    {
      id: 'homeButton',
      dataTest: 'menu-home',
      name: this.translateService.instant("sideMenu.sectionsName.myAccount.items.item1"),
      classIcon: 'material-icons',
      nameIcon: 'dashboard',
      url: 'home',
      show: true
    },
    {
      id: 'productsButton',
      dataTest: 'menu-produtos',
      name: this.translateService.instant("sideMenu.sectionsName.products.name"),
      classIcon: 'material-icons',
      nameIcon: 'storefront',
      url: 'product',
      show: true
    },
    {
      id: 'nfceButton',
      dataTest: 'menu-nfce',
      name: 'NFC-e',
      classIcon: 'material-icons',
      nameIcon: 'receipt_long',
      url: 'nfce',
      show: this.showNfceMenu
    },
    {
      id: 'pdvButton',
      dataTest: 'menu-pdv',
      name: this.translateService.instant("sideMenu.sectionsName.pdv.name"),
      classIcon: 'material-icons',
      nameIcon: "phone_android",
      url: 'pdv',
      show: true
    },
    {
      id: 'sales',
      dataTest: 'menu-vendas',
      name: this.translateService.instant("sideMenu.sectionsName.sales.name"),
      children: [
        {
          id: 'salesButton',
          dataTest: 'relatorio-vendas',
          name: this.translateService.instant("sideMenu.sectionsName.sales.options.report"),
          classIcon: 'material-icons-outlined',
          nameIcon: 'analytics',
          url: 'sales/report',
          show: true
        },
        {
          id: 'cashboxButton',
          dataTest: 'relatorio-caixa',
          name: this.translateService.instant("sideMenu.sectionsName.sales.options.cashbox"),
          classIcon: 'material-icons',
          nameIcon: 'point_of_sale',
          url: 'sales/cashbox',
          show: true
        }
      ],
      classIcon: 'material-icons-outlined',
      nameIcon: 'calculate',
      url: 'sales',
      show: true
    },
    {
      id: 'userListButton',
      dataTest: 'menu-lista-usuarios',
      name: this.translateService.instant("sideMenu.sectionsName.userList.name"),
      classIcon: 'material-icons',
      nameIcon: 'people',
      url: 'user-list',
      show: this.showUserListMenu
    },
    {
      id: 'suportButton',
      dataTest: 'menu-suporte',
      name: this.translateService.instant("sideMenu.sectionsName.support.name"),
      classIcon: 'material-icons',
      nameIcon: 'headset_mic',
      url: 'support',
      show: true
    },
    {
      id: 'logoutButton',
      dataTest: 'menu-logout',
      name: this.translateService.instant("sideMenu.sectionsName.exit.name"),
      classIcon: 'material-icons',
      nameIcon: 'logout',
      url: '',
      show: true
    },

  ];
  private _transformer = (node: OptionsNode, level: number): ExampleFlatNode => {
    return {
      expandable: !!node.children && node.children.length > 0,
      id: node.id,
      dataTest: node.dataTest,
      name: node.name,
      level: level,
      classIcon: node.classIcon,
      nameIcon: node.nameIcon,
      url: node.url,
      show: node.show
    };
  }
  collapse: boolean = true;
  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  deviceDesktop: boolean = false;
  sidebarOpened: boolean = false;
  sidebarFixed: boolean = false;
  mouseHovering: boolean = false;

  constructor(private router: Router,
    private translateService: TranslateService,
    private authenticationSerivce: AuthenticationService,
    private sessionService: SessionService,
    private configurationService: ConfigurationCompanyService,
    private wizardProduct: WizardProductService
  ) {
    this.dataSource.data = this.TREE_DATA;
  }

  hasChild = (_: number, node: ExampleFlatNode) => { return node.expandable && node.show };
  showNode = (_: number, node: ExampleFlatNode) => { return node.show && !node.expandable };

  private checkDevice() {
    const screen_size_desktop = window.matchMedia("(min-width: 600px)");
    const getScreenSizeChange = () => {
      this.deviceDesktop = screen_size_desktop.matches
    }
    getScreenSizeChange();

    window.addEventListener('resize', getScreenSizeChange);
  }

  async ngOnInit(): Promise<void> {
    this.checkDevice();
    this.showOrHideTreeNode('userListButton', this.sessionService.getDetails().isAdministrator);
    this.wizardProduct.configurationSet().then(configurations => {
      configurations.forEach(x => {
        if (x.configurationId == ConfigurationsEnum.EmitNfce)
          this.showOrHideTreeNode('nfceButton', x.configurationOptionId == ConfigurationOptionsEnum.NfceYes);
      })
    });
    this.configurationService.getEmitNfce().subscribe((r) => {
      this.showOrHideTreeNode('nfceButton', r);
    });
  }

  showSidebar() {
    this.sidebarOpened = true;
  }

  hideSidebar() {
    this.sidebarOpened = false;
  }

  toggleSidebar() {
    if (this.sidebarOpened) {
      this.hideSidebar();
    } else {
      this.showSidebar();
    }
  }

  sidebarHover(hover: boolean) {
    if (this.sidebarFixed) {
      return;
    }

    if (hover) {
      this.treeControl.collapseAll();
      this.showSidebar();
      this.mouseHovering = true;
    } else {
      this.mouseHovering = false;
      setTimeout(() => {
        if (this.sidebarFixed == true || this.mouseHovering) {
          return;
        }
        this.treeControl.collapseAll();
        this.hideSidebar();
      }, 500);
    }
  }

  clickMenuButton() {
    if (this.sidebarOpened && this.sidebarFixed == true) {
      this.hideSidebar();
      setTimeout(() => { this.sidebarFixed = false; }, 10);
    } else {
      this.showSidebar();
      this.sidebarFixed = true;
    }
  }

  logout() {
    this.authenticationSerivce.logout();
  }

  showOrHideTreeNode(nodeId: string, show: boolean) {
    this.dataSource.data.map((n) => {
      if (n.id == nodeId)
        n.show = show;
      return n;
    });
    this.forceTreeUpdate();
  }

  forceTreeUpdate() {
    const data = this.dataSource.data;
    this.dataSource.data = [];
    this.dataSource.data = data;
  }
}